import { Box, Typography } from "@mui/material";
import { Folder } from "lucide-mui";
import { styledComponent } from "../utils/styled";

const ChipRoot = styledComponent(Box)(({ isDark }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "5px 8px",
  borderRadius: "6px",
  border: "1px solid",
  borderColor: isDark ? "#2D4871" : "#4077D173",
  backgroundColor: isDark ? "#243043" : "#CFDDF2",
  boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
  maxWidth: 220,
}));

const FolderIcon = styledComponent(Folder)(({ isDark }) => ({
  fontSize: 16,
  color: isDark ? "#8D8D93" : "#434950",
}));

const FolderName = styledComponent(Typography)(({ isDark }) => ({
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 500,
  color: isDark ? "#ECEFF3" : "#434950",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: 160,
}));

export default function DraggedFolderChip({ isDark, file_name }) {
  return (
    <ChipRoot isDark={isDark}>
      <FolderIcon isDark={isDark} />
      <FolderName isDark={isDark}>{file_name}</FolderName>
    </ChipRoot>
  );
}
